export default __webpack_public_path__ + "static/media/suryakanta.83113bb4.jpeg";